import { Component, input } from "@angular/core";
import { SlickCarouselModule } from "ngx-slick-carousel";
import {
  TestimonialCardComponent,
  type TestimonialConfig,
} from "../testimonial-card/testimonial-card.component";

@Component({
  selector: "app-carousel-testimonials",
  templateUrl: "./carousel-testimonials.component.html",
  styleUrls: ["./carousel-testimonials.component.scss"],
  imports: [SlickCarouselModule, TestimonialCardComponent],
})
export class CarouselTestimonialsComponent {
  public readonly testimonialsArray = input.required<TestimonialConfig[]>();

  public readonly carouselConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  };
}
